<template>
  <div class="combin-detail">
    <el-dialog title="组合商品详情" :visible.sync="dialogVisible" width="1200px">
      <el-descriptions title="操作时间 ：21-09-18   12：35" direction="vertical" :column="7" border style="margin-bottom:40px;">
        <el-descriptions-item label="批次编码">kooriookami</el-descriptions-item>
        <el-descriptions-item label="包类型">18100000000</el-descriptions-item>
        <el-descriptions-item label="商品SKU">苏州市</el-descriptions-item>
        <el-descriptions-item label="订单编号">123</el-descriptions-item>
        <el-descriptions-item label="组合单号"> 1188 号</el-descriptions-item>
        <el-descriptions-item label="件数">12</el-descriptions-item>
        <el-descriptions-item label="打印标签">
          <el-input-number v-model="num" controls-position="right" :min="1"></el-input-number>
          <el-button type="primary" style="margin-left:20px;">打印</el-button>
        </el-descriptions-item>
      </el-descriptions>
      <el-descriptions title="操作时间 ：21-09-18   12：35" direction="vertical" :column="7" border>
        <el-descriptions-item label="批次编码">kooriookami</el-descriptions-item>
        <el-descriptions-item label="包类型">18100000000</el-descriptions-item>
        <el-descriptions-item label="商品SKU">苏州市</el-descriptions-item>
        <el-descriptions-item label="订单编号">123</el-descriptions-item>
        <el-descriptions-item label="组合单号"> 1188 号</el-descriptions-item>
        <el-descriptions-item label="件数">12</el-descriptions-item>
        <el-descriptions-item label="打印标签">
          <el-input-number v-model="num" controls-position="right" :min="1"></el-input-number>
          <el-button type="primary" style="margin-left:20px;">打印</el-button>
        </el-descriptions-item>
      </el-descriptions>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "combinDetail",
  data() {
    return {
      dialogVisible: false,
      num:''
    };
  },
};
</script>
<style lang="less" scoped></style>
